import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './e9ddd2f338caa1d50c0890aa93313190bf1d0ffbca6850e0ef678074f1f1e039.cfe-internal.js';
import Radio from './5ef320fb67e21f2489b5ee4fbbaa1df9ff485011262463e38a217182d4ce8215.cfe-internal.js';
import '../Label/ccb438053671d3f4f4866aeae6546c2d1a0a64aa48a3d0efdd175e4b2c5ded2e.cfe-internal.js';
import Label from '../Label/9a6a268368a265bce1daf89b3b2abe908557e75abd2903920d33084576c4c867.cfe-internal.js';

var _excluded = ["value", "label", "id", "className", "disabled", "inputProps", "aria-describedby"];
var RadioOption = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var value = _ref.value,
    label = _ref.label,
    id = _ref.id,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    inputProps = _ref.inputProps,
    ariaDescribedBy = _ref['aria-describedby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Label, _extends({}, rest, {
    ref: ref,
    htmlFor: id,
    className: classNames(className, styles.label, _defineProperty({}, styles.labelDisabled, disabled))
  }), /*#__PURE__*/React__default.createElement(Radio, {
    inputProps: inputProps,
    className: styles.wrappedInput,
    id: id,
    value: value,
    disabled: disabled,
    "aria-describedby": ariaDescribedBy
  }), label);
});

export { RadioOption as default };
